import { normalizeId, TRANSLATIONS_APP_NAME, TranslationsContext } from '@telia-common-components/shared';
import React from 'react';
import { AnalyticsTrigger, Button, Separator, Tooltip, TooltipToggle } from 'telia-front-react';
import { formatPrice } from '../../../util/PriceUtil';
export const Go3AppPrice = (props) => {
    var _a;
    const { productCode, appPrice, hidePrices } = props;
    const { translate, translateOrEmpty } = React.useContext(TranslationsContext);
    const getTooltip = () => (React.createElement(React.Fragment, null,
        React.createElement(TooltipToggle, { id: normalizeId(`tooltip-toggle-price-${productCode}`) },
            React.createElement("span", { className: "text-error h4" },
                React.createElement("strong", null, appPrice.discount.amount > 0
                    ? `${formatPrice(+appPrice.discount.amount)} ${translate('go3App.price.permonth')}`
                    : translateOrEmpty(TRANSLATIONS_APP_NAME, `go3App.discount.${appPrice.discount.info}`) || translate('go3App.tryForFree')))),
        React.createElement(Tooltip, { referenceElement: normalizeId(`tooltip-toggle-price-${productCode}`, true) }, translateOrEmpty(TRANSLATIONS_APP_NAME, `go3App.discount.${appPrice.discount.info}`) || translate('go3App.tryForFree.tooltip'))));
    const getDiscountOrCampaign = () => React.createElement("p", { className: "text-light" }, translate('go3App.regularPrice', { price: `${appPrice.price}` }));
    const getCampaignRules = () => {
        var _a;
        const campaignUrl = ((_a = appPrice === null || appPrice === void 0 ? void 0 : appPrice.discount) === null || _a === void 0 ? void 0 : _a.info) && translateOrEmpty(TRANSLATIONS_APP_NAME, `go3App.campaign.link.${appPrice.discount.info}`);
        if (!campaignUrl) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
            React.createElement(AnalyticsTrigger, { trigger: {
                    id: `Link - Campaign Info ${appPrice.discount.info}`,
                    callback: 'onClick',
                } },
                React.createElement(Button, { url: campaignUrl, text: translate('go3App.campaign.linkText'), link: true, target: '_blank', iconLeft: "#file-pdf", iconLeftSize: "xxs", iconClass: "text-color-normal" }))));
    };
    if (!((appPrice === null || appPrice === void 0 ? void 0 : appPrice.price) || (appPrice === null || appPrice === void 0 ? void 0 : appPrice.price) === 0) || hidePrices) {
        return null;
    }
    if ((_a = appPrice.discount) === null || _a === void 0 ? void 0 : _a.amount) {
        return (React.createElement(React.Fragment, null,
            getTooltip(),
            React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
            getDiscountOrCampaign(),
            getCampaignRules()));
    }
    return React.createElement("p", { className: "h4" }, `${formatPrice(+appPrice.price)} ${translate('go3App.price.permonth')}`);
};
